import RestClient from './rest-client'

export default class Parcel extends RestClient {
  static get url () {
    if (!this._shipmentId) {
      throw new Error('Shipment ID is required!')
    }
    return this.apiUrl + `/shipments/${this._shipmentId}/parcels`
  }
  
  static get paramKey () {
    return 'parcel'
  }

  static set shipmentId (val) {
    this._shipmentId = val
  }
}
